!function() {
  var e = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {}, t = {}, s = {}, i = e.parcelRequire5f74;
  null == i && ((i = function(e) {
    if (e in t) return t[e].exports;
    if (e in s) {
      var i = s[e];
      delete s[e];
      var n = {
        id: e,
        exports: {}
      };
      return t[e] = n, i.call(n.exports, n, n.exports), n.exports;
    }
    var o = new Error("Cannot find module '" + e + "'");
    throw o.code = "MODULE_NOT_FOUND", o;
  }).register = function(e, t) {
    s[e] = t;
  }, e.parcelRequire5f74 = i), (0, i.register)("gjV2B", function(e, t) {
    var s, i, n, o;
    s = e.exports, i = "debounce", n = function() {
      return a;
    }, Object.defineProperty(s, i, {
      get: n,
      set: o,
      enumerable: !0,
      configurable: !0
    });
    const a = (e, t) => {
      let s;
      const i = (...i) => {
        clearTimeout(s), s = setTimeout(() => {
          clearTimeout(s), e(...i);
        }, t);
      };
      return i.cancel = () => {
        clearTimeout(s), s = null;
      }, i;
    };
  });
  var n = i("gjV2B");
  customElements.get("card-product-media") || customElements.define("card-product-media", class extends HTMLElement {
    constructor() {
      super(), this.state = {
        index: 0,
        isAnimating: !1,
        timeout: null,
        observer: null,
        preloaded: new Set([ 0 ]),
        waitingForLoad: !1,
        isHovering: !1
      }, this.config = {
        log: "true" === this.getAttribute("data-enable-logging"),
        mobileSwipe: "true" === this.getAttribute("data-mobile-swipe"),
        duration: 1e3,
        transition: 300,
        hoverDelay: parseInt(this.getAttribute("data-hover-delay")) || 150,
        mq: window.matchMedia("(max-width: 1024px)")
      };
      const e = this.querySelector('[id^="PCMediaSlider-"]');
      this.elements = {
        slider: e,
        slides: e ? Array.from(e.childNodes) : [],
        progress: this.querySelector('[id^="PCMediaProgress-"]')
      }, this.handlers = new Map, this.elements.slides.length < 2 || (this.elements.progress && this.elements.slides.length > 2 && (this.progressSteps = Array.from({
        length: this.elements.slides.length
      }, (e, t) => Number(((t + 1) / this.elements.slides.length).toFixed(2)))), this.debouncedMouseEnter = (0, 
      n.debounce)(this.handleMouseEnterImmediate.bind(this), this.config.hoverDelay));
    }
    getSection=() => this.closest(".shopify-section.section--collection-product-grid");
    getViewInput=() => this.getSection()?.querySelector("input#product-card-view-index");
    isSwipeDisabled=() => this.getViewInput()?.checked || !1;
    addHandler(e, t, s, i) {
      this.handlers.set(e, i), t.addEventListener(s, i);
    }
    removeHandler(e, t, s) {
      const i = this.handlers.get(e);
      i && (t.removeEventListener(s, i), this.handlers.delete(e));
    }
    initSlides() {
      this.elements.slides.forEach((e, t) => Object.assign(e.style, 0 === t ? {
        display: "block",
        zIndex: "1"
      } : {
        display: "none",
        zIndex: "0",
        opacity: 1
      }));
    }
    async showSlide(e, t = !1) {
      if (t && this.state.isAnimating && await new Promise(e => {
        const t = () => this.state.isAnimating ? requestAnimationFrame(t) : e();
        t();
      }), this.state.isAnimating) return;
      const {slides: s} = this.elements, i = s[this.state.index], n = s[e];
      if (!i || !n) return;
      this.state.isAnimating = !0;
      const o = this.state.index;
      this.state.index = e, Object.assign(n.style, {
        display: "block",
        opacity: "0",
        zIndex: "2"
      });
      try {
        await n.animate([ {
          opacity: 0
        }, {
          opacity: 1
        } ], {
          duration: this.config.transition,
          easing: "ease-in-out",
          fill: "forwards"
        }).finished, Object.assign(i.style, 0 !== o ? {
          display: "none",
          zIndex: "0"
        } : {
          opacity: "0",
          zIndex: "0"
        }), Object.assign(n.style, {
          opacity: "1",
          zIndex: "1"
        });
      } catch (e) {
        console.error(`Animation error: ${e.message}`);
      } finally {
        this.state.isAnimating = !1;
      }
    }
    nextSlide=async () => {
      const e = (this.state.index + 1) % this.elements.slides.length;
      (this.isSlideLoaded(e) || (this.state.waitingForLoad = !0, this.clearTimeout(), 
      await this.waitForSlideLoad(e), this.state.waitingForLoad = !1, this.state.isHovering)) && (this.showSlide(e), 
      this.scheduleNextSlide());
    };
    scheduleNextSlide=() => {
      this.clearTimeout(), this.state.timeout = setTimeout(this.nextSlide, this.config.duration + this.config.transition);
    };
    isSlideLoaded=e => {
      const t = this.elements.slides[e];
      if (!t) return !1;
      const s = t.querySelector("img");
      return !s || s.complete && s.naturalHeight > 0;
    };
    waitForSlideLoad=e => new Promise(t => {
      const s = this.elements.slides[e];
      if (!s) return t();
      const i = s.querySelector("img");
      if (!i || this.isSlideLoaded(e)) return t();
      const n = () => {
        i.removeEventListener("load", n), i.removeEventListener("error", n), t();
      };
      i.addEventListener("load", n), i.addEventListener("error", n);
    });
    handleMouseEnterImmediate=() => {
      this.state.isHovering = !0, this.clearTimeout(), this.preloadSlides(), this.elements.slides.length > 1 && this.nextSlide();
    };
    handleMouseLeave=async () => {
      this.state.isHovering = !1, this.debouncedMouseEnter.cancel(), this.clearTimeout(), 
      this.state.waitingForLoad = !1, 0 !== this.state.index && await this.showSlide(0, !0);
    };
    clearTimeout() {
      this.state.timeout && (clearTimeout(this.state.timeout), this.state.timeout = null);
    }
    preloadSlides() {
      this.elements.slides.slice(1).forEach((e, t) => {
        const s = t + 1;
        this.state.preloaded.has(s) || (e.style.display = "block", this.state.preloaded.add(s));
      });
    }
    setupCycle() {
      this.initSlides(), this.addHandler("mouseenter", this, "mouseenter", this.debouncedMouseEnter), 
      this.addHandler("mouseleave", this, "mouseleave", this.handleMouseLeave);
    }
    async destroyCycle() {
      this.state.isHovering = !1, this.clearTimeout(), this.state.waitingForLoad = !1, 
      this.removeHandler("mouseenter", this, "mouseenter"), this.removeHandler("mouseleave", this, "mouseleave"), 
      this.state.preloaded.clear(), this.state.preloaded.add(0), await this.showSlide(0, !0);
    }
    updateSwipe(e) {
      this.elements.slides[e + 1] && (this.elements.slides[e + 1].style.display = "block"), 
      this.elements.progress && this.progressSteps && (this.elements.progress.style.transform = `scaleX(${this.progressSteps[e]}) translate3d(0,0,0)`), 
      this.state.index = e;
    }
    setupSwipe() {
      if (!this.config.mobileSwipe || this.isSwipeDisabled()) {
        const e = this.elements.slides[1];
        return void Object.assign(e.style, {
          zIndex: null,
          opacity: 0,
          display: "none"
        });
      }
      this.state.observer = new IntersectionObserver(e => {
        e.forEach(e => {
          e.isIntersecting && this.updateSwipe(this.elements.slides.indexOf(e.target));
        });
      }, {
        root: this.elements.slider,
        threshold: .4
      }), this.elements.slides.forEach(e => {
        Object.assign(e.style, {
          zIndex: null,
          opacity: 1
        }), this.state.observer.observe(e);
      }), this.elements.progress?.classList.remove("opacity-0"), this.elements.progress.style.display = "block";
    }
    destroySwipe() {
      this.config.mobileSwipe && (this.elements.slides.forEach((e, t) => {
        Object.assign(e.style, 0 === t ? {
          display: "block",
          zIndex: "1"
        } : {
          display: "none",
          zIndex: "0"
        }), this.state.observer?.unobserve(e);
      }), this.elements.progress?.classList.add("opacity-0"), this.elements.progress.style.display = "none", 
      this.updateSwipe(0), this.state.observer && (this.state.observer.disconnect(), this.state.observer = null));
    }
    connectedCallback() {
      this.elements.slides.length < 2 || (this.config.mq.matches ? this.setupSwipe() : this.setupCycle(), 
      this.addHandler("breakpoint", this.config.mq, "change", async e => {
        e.matches ? (await this.destroyCycle(), this.setupSwipe()) : (this.destroySwipe(), 
        this.setupCycle());
      }));
    }
    disconnectedCallback() {
      this.destroyCycle(), this.destroySwipe(), this.handlers.clear();
    }
  });
}();